import Swiper from "swiper";

export default class Global {
    constructor() {
        this.smoothScroll();
        this.propertySlider();
    }
    smoothScroll() {
        const buttons = document.querySelectorAll('.smooth-scroll');

        buttons.forEach(function(el, i) {
            el.addEventListener('click', function(ev) {
                ev.preventDefault();

                let item = document.querySelector(el.getAttribute('href'));
                let offset = item.offsetTop - document.querySelector('header').offsetHeight;

                if (document.querySelector('#property')) {
                    offset -= document.querySelector('#property nav').offsetHeight;
                }
                console.log(offset)
                window.scrollTo({
                    'behavior': 'smooth',
                    'left': 0,
                    'top': offset
                });
            });
        });
    }

    propertySlider () {
        if (document.querySelector('#properties')) {
            const slider = new Swiper('#properties .swiper-container', {
                sliderPerView: 1,
                spaceBetween: 50,
                breakpoints: {
                    576: {
                        slidesPerView: 2,
                        spaceBetween: 15
                    },
                    992: {
                        slidesPerView: 3,
                        spaceBetween: 30
                    },

                },
            })
        }
    }
}
